<main-app-header></main-app-header>
<div class="thankyou-bg privacy-policy-bg background-blue">
  <div class="logo">
    <!-- <div>
      <a [routerLink]="['/']"><img src="./assets/images/logo.png" /></a>
      <span style="margin-top:-20px" class="trademark2">™</span>
    </div> -->
  </div>
  
  <div class="thankyou-box box-shadow privacy-policy-box">
    <!-- <div class="backlink"><a (click)="backClicked()"><i class="fas fa-chevron-left"></i> Home</a></div> -->
    <div class="container">
      <div id="phoneEmail">
        <label for="Mobile" class="material-icons">
          <input type="radio" id="phoneCheck" value="Mobile" (click)="selectedOption()" name="mobile_or_desktop" checked={{phoneCheck}}>
          <span class="material-icons-outlined" style="color: #B3CEFB">
            phone_iphone
          </span>
        </label>
        <label for="Desktop" class="material-icons">
          <input type="radio" id="emailCheck" value="Desktop" (click)="selectedOption()" name="mobile_or_desktop" checked={{emailCheck}}>
          <span class="material-icons-outlined" style="color: #B3CEFB">
            desktop_windows
          </span>
        </label>
      </div>
      <div>
        <h3 style= "font-size: 1.35rem">Mobile&ensp;Desktop</h3>
      </div>
    </div>
    <div id="phoneIsChecked">
      <div class="toc-columns">
        <div class="toc-col">
          <a (click)="scrollTo('iconLegend')">1. Icon legend</a>
          <a (click)="scrollTo('chatScreen')">2. Chat screen</a>
          <a (click)="scrollTo('chatRoom')">3. Chat room</a>
          <a (click)="scrollTo('dialPad')">4. Dial pad</a>
          <a (click)="scrollTo('contacts')">5. Contacts</a>
        </div>
        <div class="toc-col">
          <a (click)="scrollTo('meeting')">6. Meeting</a>
          <a (click)="scrollTo('login')">7. Login</a>
          <a (click)="scrollTo('callOptions')">8. Options during a call</a>
          <a (click)="scrollTo('changePassword')">9. Change password</a>
          <a (click)="scrollTo('changeEmail')">10. Change email</a>
        </div>
        <div class="toc-col">
          <a (click)="scrollTo('changePhone')">11. Change phone number</a>
          <a (click)="scrollTo('changeDisplayName')">12. Dashboard user management</a>
          <a (click)="scrollTo('managePlan')">13. Manage Subscription</a>
          <a (click)="scrollTo('changePayment')">13.1. Change payment</a>
          <a (click)="scrollTo('cancelSub')">13.2 Cancel subscription</a>
          <a (click)="scrollTo('changeSub')">13.3 Change subscription</a>
          <a (click)="scrollTo('createSub')">13.4.Creating subscription from a member or manager</a>

        </div>
      </div>
      <h4 id="iconLegend">1.Icon legend</h4>
      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/one-one-chat-icon.png" /></a>
        <p id="align-center">
          - Initiate one-to-one chat
        </p>

      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/group-chat-icon.png" /></a>
        <p id="align-center">
          - Initiate a group chat
        </p>

      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/ephemeral-on-icon.png" /></a>
        <p id="align-center">
          - Indicates that the ephemeral timer is on
        </p>

      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/select-all-items.png" /></a>
        <p id="align-center">
          - Select all items
        </p>
      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/cancel-button.png" /></a>
        <p id="align-center">
          - Cancel button
        </p>

      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/ephemeral-time-left.png" /></a>
        <p id="align-center">
          - Indicates the remaining ephemeral time left on a message, before the message gets deleted
        </p>

      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/group-call-button.png" /></a>
        <p id="align-center">
          - Initiate a group call
        </p>

      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/contacts-button.png" /></a>
        <p id="align-center">
          - Switch between Titanium™ contacts, Groups and all contacts including non-Titanium™ ones
        </p>

      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/undread-message.png" /></a>
        <p id="align-center">
          - Bouncing number indicates unread messages
        </p>

      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/delivered-message.png" /></a>
        <p id="align-center">
          - One checkmark indicates that the message was delivered
        </p>

      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/read-message.png" /></a>
        <p id="align-center">
          - Two checkmarks indicate that the message was read, and the ephemeral timer will start the countdown
        </p>

      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/calls-list-button.png" /></a>
        <p id="align-center">
          - During a call, check the current list of all ongoing calls
        </p>

      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/start-new-call.png" /></a>
        <p id="align-center">
          - During a call, the user can start a new call which pauses the current call
        </p>

      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/merge-calls.png" /></a>
        <p id="align-center">
          - During a call, if the user started a new call, then they can merge the two calls into a conference call
        </p>

      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/options-during-call.png" /></a>
        <p id="align-center">
          - During a call, the user can view the options which are available during a call
        </p>

      </div>

      <div class="cheat-sheet-image icon-div-adjustment" style="display:inline-block">
        <a><img src="./assets/images/group-info-participant.png" /></a>
        <p id="align-center" style="margin-right:30px">
          - Clicking on the X button will remove the user from the group chat, the admin of the group can make other participants' admin, by clicking the admin button
        </p>

      </div>

      <h4 id="chatScreen">2.Chat screen</h4>
      <p id="align-left">
        - Group chat is indicated by displaying the group icon, one on one chat is indicated by displaying the initials of the user you're chating with.
      </p>
      <p id="align-left">
        - The clock icon indicates that the ephemeral timer for your messages is on.
      </p>
      <p id="align-left">
        - Create a group chat by selecting the second icon on the top left, then select the participants for the group.
      </p>
      <p id="align-left">
        - Use the trash can icon to delete a chat by selecting the chat room.
      </p>
      <p id="align-left">
        - By sliding on a chat room, the user can hide that chat room. It can be found on the second option in the contact section where the groups are located.
      </p>
      <div class="cheat-sheet-image"><a><img src="./assets/images/chat-screen.png" /></a></div>
      <div class="cheat-sheet-image"><a><img src="./assets/images/delete-chat-room.png" /></a></div>
      <h4 id="chatRoom">3.Chat room</h4>
      <p id="align-left">
      <p id="align-left">
        - The ephemeral timer is on by default and is set to 1 hour.
      </p>
      <p id="align-left">
        - The current set ephemeral time can be seen below the user/group name.
      </p>
      <p id="align-left">
        - The ephemeral timer can be changed by clicking the three dots on the top right, then selecting the ephemeral timer.
      </p>
      <p id="align-left">
        - The timer will start the countdown once the user you're chatting with sees the message you have sent. The count down can be seen on the bottom left of your message.
      </p>
      <p id="align-left">
        - Attachments can be sent by clicking the paper clip and then selecting the source of the attachment.
      </p>
      <p id="align-left">
        - Audio messages can be sent by clicking the microphone icon on the bottom left.
      </p>
      <p id="align-left">
        - Pressing on a message will pop up a menu with options to reply, delete or forward a message.
      </p>
      <p id="align-left">
        - Group info can be accessed by clicking the three dots, then select group info, it will display who is the current admin of the group and the current participants.
      </p>
      <p id="align-left">
        - The admin of the group can add users to the group, remove them or make a user admin.
      </p>
      <div class="cheat-sheet-image"><a><img src="./assets/images/chat-room.png" /></a></div>
      <div class="cheat-sheet-image"><a><img src="./assets/images/ephemeral-timer-screen.png" /></a></div>
      <div class="cheat-sheet-image"><a><img src="./assets/images/chat-menu.png" /></a></div>
      <div class="cheat-sheet-image"><a><img src="./assets/images/options-menu-chat.png" /></a></div>
      <div class="cheat-sheet-image"><a><img src="./assets/images/group-info-screen.png" /></a></div>

      <h4 id="dialPad">4.Dial pad</h4>
      <p id="align-left">

      </p>
      <div class="cheat-sheet-image"><a><img src="./assets/images/dial-pad-screen.png" /></a></div>

      <h4 id="contacts">5.Contacts</h4>
      <p id="align-left">
        - The top left icon displays your Titanium™ contacts.
      </p>
      <p id="align-left">
        - The middle button displays only the group chats you are a part of.
      </p>
      <p id="align-left">
        - Sliding on a chat room from left to right will restore the chat room if it was hidden from the chat rooms tab.
      </p>
      <p id="align-left">
        - Sliding on a chat room from right to left will give the user an option to leave the chat room.
      </p>
      <p id="align-left">
        - Contacts which are not part of Titanium can be displayed by clicking on the icon without the Titanium™ logo.
      </p>
      <p id="align-left">
        - Non-Titanium™ users can be invited to join Titanium™ by clicking the invite button, or clicking on the contact and then selecting send which phone number to send the invite.
      </p>
      <p id="align-left">
        - To create a new contact, press on the icon with the plus sign and enter the contact details.
      </p>
      <!--<div class="cheat-sheet-image"><a><img src="./assets/images/titanium-contacts.png" /></a></div>-->
      <div class="cheat-sheet-image"><a><img src="./assets/images/normal-contacts.png" /></a></div>
      <div class="cheat-sheet-image"><a><img src="./assets/images/contact-details.png" /></a></div>
      <div class="cheat-sheet-image"><a><img src="./assets/images/create-contact.png" /></a></div>
      <div class="cheat-sheet-image"><a><img src="./assets/images/chat-groups-contact.png" /></a></div>

      <h4 id="meeting">6.Meeting</h4>
      <p id="align-left">
        - In the meetings tab you can view all of your scheduled meetings. Pressing the info icon will display the option to join the meeting, edit/delete the meeting, add the meeting to the calendar or to resend the meeting invite to all participants.
      </p>
      <p id="align-left">
        - To schedule a meeting, press the icon on the top right. enter the meeting details, select the participants and schedule the meeting.
      </p>
      <p id="align-left">
        - The meeting info will display the meeting details and all the participants that are added to the meeting.
      </p>
      <p id="align-left">
        - All participants will receive a meeting invite.
      </p>
      <div class="cheat-sheet-image"><a><img src="./assets/images/meeting-tab-info.png" /></a></div>
      <div class="cheat-sheet-image"><a><img src="./assets/images/schedule-meeting.png" /></a></div>
      <div class="cheat-sheet-image"><a><img src="./assets/images/meeting-info.png" /></a></div>

      <h4 id="login">7.Login</h4>
      <p id="align-left">
        - To open the side menu, press the top left button.
      </p>
      <p id="align-left">
        - To go to the login screen, press on the logged out text next to the user icon. Once there, click on sign in and enter your account details.
      </p>
      <p id="align-left">
        - Once logged in, going to the side menu, the settings tab and the manage account will appear.
      </p>
      <p id="align-left">
        - Manage account will redirect the user to the website where they can make changes to their account.
      </p>
      <p id="align-left">
        - To logout, click on your username then click the logout button.
      </p>
      <p id="align-left">
        - The check for update button (Android only) will check for updates and if an update is available it will display a message to the user that there's a new version available for download.
      </p>

      <div class="cheat-sheet-image"><a><img src="./assets/images/side-menu.png" /></a></div>
      <div class="cheat-sheet-image"><a><img src="./assets/images/login-screen.png" /></a></div>
      <div class="cheat-sheet-image"><a><img src="./assets/images/login-screen2.png" /></a></div>
      <div class="cheat-sheet-image"><a><img src="./assets/images/dashboard-screen.png" /></a></div>


      <h4 id="callOptions">8.Options during a call</h4>
      <p id="align-left">
        - During a single call, click on the phone icon on the bottom right, then select and start a new call with a contact. Pausing for the first call, the bottom right icon will change to the merge icon, pressing it will combine the two calls into one group call.
      </p>
      <p id="align-left">
        - During a single or group call, click on the top right icon to open the option menu.
      </p>
      <p id="align-left">
        - During a call users can see the list of all participants, change their call layout or check the current list of all ongoing calls or redirect a call during a single call.
      </p>
      <div class="cheat-sheet-image"><a><img src="./assets/images/single-call1.png" /></a></div>
      <div class="cheat-sheet-image"><a><img src="./assets/images/single-call2.png" /></a></div>
      <div class="cheat-sheet-image"><a><img src="./assets/images/merged-call.png" /></a></div>
      <div class="cheat-sheet-image"><a><img src="./assets/images/call-options.png" /></a></div>

      <h4 id="changePassword">9.Change password</h4>

      <p id="align-left">
        - From the dashboard, enter the change password tab, the fields will require the old password and to confirm the new password, a popup will display a confirmation of the change.
      </p>
      <p id="align-left">
        - After changing the password, the user would have to sign in again.
      </p>
      <div class="cheat-sheet-image"><a><img src="./assets/images/change-password.png" /></a></div>

      <h4 id="changeEmail">10.Change email</h4>

      <p id="align-left">
        - From the dashboard, enter the change email tab, the fields will require your current password and the new email address, a popup will display a confirmation of the change.
      </p>
      <div class="cheat-sheet-image"><a><img src="./assets/images/change-email.png" /></a></div>

      <h4 id="changePhone">11.Change phone number</h4>

      <p id="align-left">
        - From the dashboard, enter the change phone number tab, the fields will require your current password the new phone number, after submitting you will receive a one time password on your new phone number, after confirming the otp, a popup will display a confirmation of the change.
      </p>
      <div class="cheat-sheet-image"><a><img src="./assets/images/change-phone-number.png" /></a></div>

      <h4 id="changeDisplayName">12.Dashboard user management</h4>

      <p id="align-left">
        - From the dashboard, the master user can add temp users with or without an expiration date. The number of available users is based on the plan. Users can change their plan by pressing the change plan button in the manage plan section, then select the new plan and the number of seats required.
      </p>
      <p id="align-left">
        - Temp users can be set to be normal members of the group or set to be managers of the group, then they can add, delete and update users.
      </p>
      <p id="align-left">
        - Activated temp users are displayed in green in the Active field, users who are yet to set up their account are in red.
      </p>
      <p id="align-left">
        - To send a reminder email to a user who is yet to set up their account, press the letter icon and select the mailing service you use. It will autofill a template which can be modified.
      </p>
      <p id="align-left">
        - Members and managers can create their own subscription by going to the Manage Plan section.
      </p>
      <div class="cheat-sheet-image"><a><img src="./assets/images/manage-user1.png" /></a></div>
      <div class="cheat-sheet-image"><a><img src="./assets/images/manage-user2.png" /></a></div>

      <h4 id="managePlan">13.Manage Plan</h4>

      <p id="align-left">
        - From the dashboard, enter the manage plan tab. Here the master user can change their payment card, change their plan or cancel their subscription.
      </p>
      <div class="cheat-sheet-image"><a><img src="./assets/images/manage-plan.png" /></a></div>


      <h4 id="changePayment">13.1.Change payment</h4>

      <p id="align-left">
        - From the dashboard, enter the manage plan tab, then press change payment, the fields will require your to enter the new card details, a popup will display a confirmation of the change.
      </p>
      <div class="cheat-sheet-image"><a><img src="./assets/images/change-payment.png" /></a></div>

      <h4 id="cancelSub">13.2.Cancel subscription</h4>

      <p id="align-left">
        - From the dashboard, enter the manage plan tab, then press cancel sub, click unsubscribe and delete your account permanently, a popup will display to confirmation the choice.
      </p>
      <div class="cheat-sheet-image"><a><img src="./assets/images/cancel-sub.png" /></a></div>

      <h4 id="changeSub">13.3.Change subscription</h4>

      <p id="align-left">
        - From the dashboard, enter the manage plan tab, then press change plan, here you can choose to upgrade or downgrade your plan by selecting the desired plan, then select the amount of seats, confirming will update your current plan to the new one.
      </p>
      <div class="cheat-sheet-image"><a><img src="./assets/images/cancel-sub.png" /></a></div>
      <h4 id="createSub">13.4.Creating subscription from a member or manager</h4>

      <p id="align-left">
        - From the dashboard, enter the manage plan tab, then press Create my own subscription, a warning message will pop up notifying you that creating your own subscription will remove you from your current group.
      </p>
      <p id="align-left">
        - Pressing continue will show all the available plans, select a plan, then select the number of seats required and proceed with the payment tab where you enter your details, to finalize the subscription.
      </p>
      <div class="cheat-sheet-image"><a><img src="./assets/images/sub.png" /></a></div>
      <div class="cheat-sheet-image"><a><img src="./assets/images/sub2.png" /></a></div>

    </div>
    <!--desktop guide-->
    <div id="emailIsChecked">
      <h3 style="color: #000; margin-top: 1.5rem; "> Desktop User Guide</h3>
      <h4> Table of Contents</h4>
      <div class="toc-columns">
        <div class="toc-col">
          <a (click)="scrollTo('iconLegend-desktop')">1. Icon legend</a>
          <a (click)="scrollTo('chatScreen-desktop')">2. Chat screen</a>
          <a (click)="scrollTo('chatRoom-desktop')">3. Chat room</a>
          <a (click)="scrollTo('contacts-desktop')">4. Contacts</a>
          <a (click)="scrollTo('meeting-desktop')">5. Meetings</a>
        </div>
        <div class="toc-col">
          <a (click)="scrollTo('login-desktop')">6. Login</a>
          <a (click)="scrollTo('callOptions-desktop')">7. Options during a call</a>
          <a (click)="scrollTo('mac-install')">8. First time Mac install</a>
        </div>
      </div>

      <h4 id="iconLegend-desktop">1.Icon legend</h4>
      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/start-chat.png" /></a>
        <p id="align-center">
          - Initiate one-to-one chat with the selected user
        </p>
      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/start-group-chat.png" /></a>
        <p id="align-center">
          - Initiate group chat with the selected users
        </p>

      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/current-status.png" /></a>
        <p id="align-center">
          - Indicates current status
        </p>

      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/hide-timeline.png" /></a>
        <p id="align-center">
          - Hide/show timeline
        </p>
      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/open-home.png" /></a>
        <p id="align-center">
          - Open home screen
        </p>
      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/unread-messages.png" /></a>
        <p id="align-center">
          - Displays the number of unread messages -
        </p>

      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/call-group.png" /></a>
        <p id="align-center">
          - Call the group
        </p>
      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/ephemeral-messages.png" /></a>
        <p id="align-center">
          - Change/set the ephemeral timer
        </p>

      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/create-meeting.png" /></a>
        <p id="align-center">
          - Schedule a meeting
        </p>

      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/current-ephemeral-time.png" /></a>
        <p id="align-center">
          - Displays the current ephemeral time left on the message
        </p>

      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/send-ephemeral.png" /></a>
        <p id="align-center">
          - Indicates that the next message that will be sent is ephemeral
        </p>

      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/read-message-desktop.png" /></a>
        <p id="align-center">
          - Indicates that the message is read
        </p>

      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/more-options.png" /></a>
        <p id="align-center">
          - Displays a menu with options to reply, delete or forward a message
        </p>

      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/admin-group.png" /></a>
        <p id="align-center">
          - Indicates that you are admin of the group
        </p>
      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/delete-chat.png" /></a>
        <p id="align-center">
          - Delete chat
        </p>
      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/contacts-tab.png" /></a>
        <p id="align-center">
          - Display the contacts tab
        </p>
      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/meetings-tab.png" /></a>
        <p id="align-center">
          - Display the meetings tab
        </p>
      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/invite-participants-meeting.png" /></a>
        <p id="align-center">
          - Invite participants to a meeting
        </p>
      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/transfer-call.png" /></a>
        <p id="align-center">
          - Transfer call
        </p>
      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/start-new-call-desktop.png" /></a>
        <p id="align-center">
          - Start a new call
        </p>

      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/call-settings.png" /></a>
        <p id="align-center">
          - Call settings
        </p>

      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/call-options-desktop.png" /></a>
        <p id="align-center">
          - Call options
        </p>

      </div>

      <div class="cheat-sheet-image-icon icon-div-adjustment">
        <a class="image-adjustment"><img src="./assets/images/share-screen.png" /></a>
        <p id="align-center">
          - Share screen
        </p>

      </div>

      <h4 id="chatScreen-desktop">2.Chat screen</h4>
      <p id="align-left">
        - Group chat is indicated by displaying the group icon, one on one chat is indicated by displaying the initials of the user you're chating with.
      </p>
      <p id="align-left">
        - The clock icon indicates that the ephemeral timer for your messages is on.
      </p>
      <p id="align-left">
        - Create a group chat by selecting the icon on the top right, then select the participants for the group.
      </p>
      <p id="align-left">
        - Use the trash can icon to delete a chat by right clicking on the chat room.
      </p>
      <div class="cheat-sheet-image"><a><img src="./assets/images/chat-screen-desktop.png" /></a></div>
      <div class="cheat-sheet-image"><a><img src="./assets/images/chat-screen-delete-desktop.png" /></a></div>

      <h4 id="chatRoom-desktop">3.Chat room</h4>
      <p id="align-left">
      <p id="align-left">
        - The ephemeral timer is off by default.
      </p>
      <p id="align-left">
        - The current set ephemeral time can be checked by clicking on the top right ephemeral timer icon.
      </p>
      <p id="align-left">
        - The ephemeral timer can be changed by clicking the top right ephemeral timer icon, then select the ephemeral time.
      </p>
      <p id="align-left">
        - The timer will start the countdown once the user you're chatting with sees the message you have sent. The count down can be seen on the bottom left of your message.
      </p>
      <p id="align-left">
        - Attachments can be sent by clicking the paper clip and then selecting the file of the attachment.
      </p>
      <p id="align-left">
        - Audio messages can be sent by clicking the microphone icon on the bottom left.
      </p>
      <p id="align-left">
        - Holding on a message will pop up a menu with options to reply, delete, forward a message or add the user to your contacts.
      </p>
      <p id="align-left">
        - Clicking the shield icon on the top right will display the conversation devices.
      </p>
      <p id="align-left">
        - Group info can be accessed by clicking the three dots, then select group info, it will display who is the current admin of the group and the current participants.
      </p>
      <p id="align-left">
        - The admin of the group can add users to the group, remove them or make a user admin.
      </p>
      <p id="align-left">
        - To add a new line while composing a new message on the desktop app, hit SHIFT + ENTER.
      </p>
      <div class="cheat-sheet-image-desktop"><a><img src="./assets/images/chat-room-desktop.png" /></a></div>
      <div class="cheat-sheet-image-desktop"><a><img src="./assets/images/ephemeral-timer-screen-desktop.png" /></a></div>
      <div class="cheat-sheet-image-desktop"><a><img src="./assets/images/chat-menu-desktop.png" /></a></div>
      <div class="cheat-sheet-image-desktop"><a><img src="./assets/images/group-info-screen-desktop.png" /></a></div>

      <h4 id="contacts-desktop">4.Contacts</h4>
      <p id="align-left">
        - Pressing the top left icon displays your contacts.
      </p>
      <p id="align-left">
        - Contacts which are not part of Titanium™ won't display their current status.
      </p>
      <p id="align-left">
        - To create a new contact, press on the top right add contact button and enter the contact details.
      </p>
      <p id="align-left">
        - To edit contact details, select the contact and click on the pen icon.
      </p>
      <div class="cheat-sheet-image-desktop"><a><img src="./assets/images/contacts-desktop.png" /></a></div>
      <div class="cheat-sheet-image-desktop"><a><img src="./assets/images/add-contact-desktop.png" /></a></div>

      <h4 id="meeting-desktop">5.Meeting</h4>
      <p id="align-left">
        - In the meetings tab you can view all of your scheduled meetings. Pressing the info icon will display the option to join the meeting or to edit/delete the meeting.
      </p>
      <p id="align-left">
        - The meeting info will display the meeting details and all the participants that are added to the meeting.
      </p>
      <p id="align-left">
        - To start a group call, create a group from the top right start a chat room icon, add all participants and call the group, to schedule a meeting, create or enter a group, press the top right schedule a meeting icon and add all the participants, if you want to schedule a meeting for later, press the toggle button and enter the meeting details, select the participants and schedule the meeting.
      </p>
      <p id="align-left">
        - All participants will receive a meeting invite.
      </p>
      <p id="align-left">
        - Only Titanium users can enter meetings.
      </p>
      <div class="cheat-sheet-image-desktop"><a><img src="./assets/images/meeting-tab-desktop.png" /></a></div>
      <div class="cheat-sheet-image-desktop"><a><img src="./assets/images/group-call-desktop.png" /></a></div>
      <div class="cheat-sheet-image-desktop"><a><img src="./assets/images/schedule-meeting-desktop.png" /></a></div>
      <div class="cheat-sheet-image-desktop"><a><img src="./assets/images/meeting-invite-desktop.png" /></a></div>

      <h4 id="login-desktop">6.Login</h4>
      <p id="align-left">
        - To go to the login screen, press the home button located on the top left. Once there, click on sign in and enter your account details.
      </p>
      <p id="align-left">
        - Once logged in, to manage your account, click on the home button, then click on manage account, you will be redirected to the website.
      </p>
      <p id="align-left">
        - The dashboard allows the user to manage their account.
      </p>
      <p id="align-left">
        - To change your presence status, click on your phone number near the home button.
      </p>
      <p id="align-left">
        - To logout, click on the home button, then click on log out.
      </p>

      <div class="cheat-sheet-image-desktop"><a><img src="./assets/images/log-in-desktop.png" /></a></div>
      <div class="cheat-sheet-image-desktop"><a><img src="./assets/images/manage-desktop.png" /></a></div>
      <div class="cheat-sheet-image-desktop"><a><img src="./assets/images/presence-status.png" /></a></div>
      <div class="cheat-sheet-image-desktop"><a><img src="./assets/images/log-out-desktop.png" /></a></div>

      <h4 id="callOptions-desktop">7.Options during a call</h4>

      <p id="align-left">
        - During a single or group call, click on the three dots to open the settings menu, from there you can adjust settings, invite users or share your screen.
      </p>
      <p id="align-left">
        - Invite participants to the group or change the admin status of participants, by entering the group options from the bottom right button.
      </p>
      <p id="align-left">
        - During a call, users can put the call on hold, transfer the call or start a new call or check the current list of all ongoing calls, by pressing the top left button to open the menu.
      </p>
      <div class="cheat-sheet-image-desktop"><a><img src="./assets/images/call-settings-desktop.png" /></a></div>
      <div class="cheat-sheet-image-desktop"><a><img src="./assets/images/invite-participants.png" /></a></div>
      <div class="cheat-sheet-image-desktop"><a><img src="./assets/images/call-menu-desktop.png" /></a></div>

      <h4 id="mac-install">8. First time Mac install</h4>
      <p id="align-left">- A first-time installer to MacOS will need to grant permission to Titanium under screen & system audio recording.</p>
      <p id="align-left">- From the browser in the downloads tab you will see the file, open it and follow the instructions, the app will require couple of permissions. </p>
      <div class="cheat-sheet-image-desktop"><a><img src="./assets/images/mac_install.png" /></a></div>
      <div class="cheat-sheet-image-desktop"><a><img src="./assets/images/install-1m.png" /></a></div>
      <div class="cheat-sheet-image-desktop"><a><img src="./assets/images/install-2m.png" /></a></div>
      <div class="cheat-sheet-image-desktop"><a><img src="./assets/images/install-3m.png" /></a></div>
      <div class="cheat-sheet-image-desktop"><a><img src="./assets/images/install-4.png" /></a></div>
      <div class="cheat-sheet-image-desktop"><a><img src="./assets/images/install-5.png" /></a></div>
      <div class="cheat-sheet-image-desktop"><a><img src="./assets/images/install-6.png" /></a></div>
      <div class="cheat-sheet-image-desktop"><a><img src="./assets/images/install-7.png" /></a></div>
      <div class="cheat-sheet-image-desktop"><a><img src="./assets/images/install-8.png" /></a></div>
    </div>
  </div>
</div>
